var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commission"},[(_vm.fee && +_vm.fee.percent)?_c('div',[_c('span',{staticClass:"commission__label"},[_vm._v(_vm._s(_vm.locale.commissionOfSelectedPS)+": ")]),_c('span',{staticClass:"commission__info"},[_vm._v(" "+_vm._s(_vm.fee.value)+" ("+_vm._s(_vm.fee.percent * 100)+"%) ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }